// Vendors
import $ from 'jquery';
import 'jquery.scrollto/jquery.scrollTo.min';
import 'jquery.localscroll/jquery.localScroll.min';
import 'waypoints/lib/jquery.waypoints.min';

const elements = $('.animated-grid');
elements.each((index, element) => {
  let current = $(window).scrollTop();
  // var topOffset = $(element).offset().top;
  let total = $(window).height() - current;
  // current = current - topOffset - 300;
  let currPosition = $(element).data('left');
  let trackLength = 300;

  $(window).scroll(function (event) {
    current = $(window).scrollTop();
    let newPosition = trackLength * (current / total);
    $(element).css({ left: currPosition + newPosition + 'px' });
  });
});
